import { render } from "./Widget5.vue?vue&type=template&id=b3f5b15e&ts=true"
import script from "./Widget5.vue?vue&type=script&lang=ts"
export * from "./Widget5.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__